import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'dmmp-footer-grid',
  templateUrl: './footer-grid.component.html'
})
export class FooterGridComponent implements OnInit {

  @Input() module
  @Input() identifier
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()

  constructor() { }

  ngOnInit(): void {
    this.module?.content?.row?.forEach(rowItem => {
      rowItem.column.isCollapse = false
    })
  }

}
